<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<div>
  <profile-pds-p-spinner p-spinner [size]="size ? size : { base: 'small', l: 'medium' }" aria-hidden="true"></profile-pds-p-spinner>
  @if (text) {
    <div class="loader-label">{{ text }}</div>
  } @else if (loadingLabel) {
    <span class="profile:sr-only">{{ loadingLabel }}</span>
  }
</div>
